module.exports = __webpack_public_path__ + "img/forbes-head.4df7f62e.svg";